module.exports = __webpack_public_path__ + "img/admin-a3.3679cae1.png";